import { Route, Routes } from 'react-router-dom'
import CategoriesPage from '../../pages/main/categories/page'
import CategoryPage from '../../pages/main/categories/details'


export default function CategoryNav() {
    return (
        <Routes>

            <Route path="/" element={<CategoriesPage />} />
            <Route path="/:slug" element={<CategoryPage />} />

        </Routes>
    )
}
